$(document).ready(function () {
  //0.5秒かけてフェードイン
  $("body").css("opacity", "0").animate({ opacity: 1 }, 300);
  //PAGE TOP ボタンの処理
  const pageTop_btn = document.querySelector(".l-footer-pagetop");
  if (pageTop_btn) {
    pageTop_btn.addEventListener("click", function () {
      window.scroll({ top: 0, behavior: "smooth" });
    });
  }
});
//グローバルナビのアコーディオン（PC）
$(document).ready(function () {
  $(".l-header-nav__parent > span").click(function () {
    const parentItem = $(this).parent(); // クリックしたspanの親li要素

    // .l-header-nav__parentにactiveクラスをトグル
    parentItem.toggleClass("active");

    // ulのスライド開閉
    parentItem.children("ul").stop(true, true).slideToggle(300);
  });
});
//MENU
const menuButton = document.getElementById("menu-button");
const menuLabel = document.getElementById("menu-label");
const menu = document.getElementById("menu");
const body = document.body;
const overlay = document.getElementById("overlay");
function toggleMenu() {
  if (!body.classList.contains("menu-open")) {
    body.classList.add("menu-open");
    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "閉じる");
    menu.inert = false;
    if (menuLabel) {
      menuLabel.textContent = "CLOSE";
    }
  } else {
    body.classList.remove("menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニュー");
    menu.inert = true;
    if (menuLabel) {
      menuLabel.textContent = "MENU";
    }
  }
}
if (menuButton) {
  menuButton.addEventListener("click", toggleMenu);
}
if (overlay) {
  overlay.addEventListener("click", toggleMenu);
}
//MENU内開閉
$(document).ready(function () {
  $(".l-header-menu__parent > span").on("click", function () {
    const parent = $(this).parent(); // `.l-header-menu__parent` を取得
    parent.toggleClass("active"); // `active` クラスを切り替え
    parent.children("ul").slideToggle(); // 直下の `ul` を開閉
  });
});
//アンカーリンク
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href");
    const target = document.querySelector(targetId);
    const headerHeight = document.querySelector("header").offsetHeight; // ヘッダーの高さ取得
    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight; // ヘッダーの高さ分ずらす
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  });
});